angular.module('app')
.config(function($stateProvider) {
  $stateProvider
    .state('admin',{
      url: '/admin',
      templateUrl: '../views/admin.html',
      controller: 'authCtrl',
      onEnter: function($state, auth){
        if(auth.isLoggedIn()){
          $state.go('admin2');
        }
      }
    });
});
